var map = {
	"./Acceptedrequest.png": 1249,
	"./Screenshot (8).png": 1740,
	"./Vector.png": 8101,
	"./allrequest.png": 3967,
	"./box.png": 8866,
	"./buckets.png": 5218,
	"./franchise.png": 5141,
	"./franchiseWhite.png": 2025,
	"./logo.png": 6706,
	"./pendingrequest.png": 9947,
	"./refunded.png": 9468,
	"./rejectedrequest.png": 3069,
	"./userlogo.png": 2226,
	"./welotaLogo_Dashboard.png": 3376
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6183;